import { APIConfiguration } from '@savgroup-front-common/configuration';
import { CARRIER_PRODUCT_TYPE } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}transportmethods`;

export interface TransportMethodSummary {
  id: string;
  uniqueName?: string;
  name?: string;
  productType: CARRIER_PRODUCT_TYPE;
  reach: string;
  localeList?: {
    cultureCode: string;
    key: string;
    label: string;
    imagePath?: string;
    description?: string;
    keywordList?: string[];
  }[];
}

export const getTransportMethodsRequest = (): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getTransportMethodsQuery = async (): Promise<
  BackResponse<TransportMethodSummary[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<TransportMethodSummary[]>>(
      getTransportMethodsRequest(),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
